import I18n from 'I18n';
export const getFileFilteringErrorMessageKey = filterType => `FileManagerLib.panels.tiles.${filterType}`;
export const getFileFilteringErrorMessageOptions = extensions => ({
  count: extensions.count(),
  extensions: I18n.formatList(extensions.map(extension => `.${extension}`).toArray())
});
export const getFileFilteringErrorMessage = (extensions, filterType) => I18n.text(getFileFilteringErrorMessageKey(filterType), getFileFilteringErrorMessageOptions(extensions));